module.exports = __webpack_public_path__ + "img/bigwin-text_th.5d506d8d.png";